module.exports = __webpack_public_path__ + "static/img/1696_phase_function_Paper_PointsHejduk_Prediction.2a10f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1696_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0Ct8
// module chunks = 0